import { categoryConstants } from "../actions/documents/category";

export default function categoryDocuments(state, { type, payload }) {
  // risolve code smell di sonar
  let defaultState = typeof state === "undefined" ? [] : state;

  if (type === categoryConstants.GET_NEW_TREE_CATEGORY_SUCCESS) {
    return payload;
  } 
  return defaultState;
  
}
